// https://docs.appbase.io/docs/reactivesearch/gettingstarted/

// Reactivesearch manual: https://opensource.appbase.io/reactive-manual/
// Playground: https://opensource.appbase.io/playground/?selectedKind=Base%20components%2FDataController&selectedStory=Basic&full=0&addons=1&stories=1&panelRight=0&addonPanel=storybooks%2Fstorybook-addon-knobs

// Mirage: https://github.com/appbaseio/mirage

// npx webpack --config showSearchApp.webpack.config.js

//Using React components in non-React websites
//https://medium.com/@sevenleaps/using-react-components-in-non-react-websites-

//OBS OBS OBS OBS
//
//            API key genereres i Kibana
//            Husk Cors policy i elastic search instance. Hvis ikke denne inkluderer localhost - så funker det ikke. For produksjon så må det selvfølgelig brukes riktig domene
//
//              /https?:\/\/gjerrigknark\.com/
//              /https?:\/\/localhost(:[0-9]+)?/
//
//            For å lage Api key token så må en base64 encode(API KEY ID:API KEY)

import React, { Component } from 'react';
import {ReactiveBase, DataSearch, SingleDataList, ReactiveList, ResultCard, TagCloud, SelectedFilters} from '@appbaseio/reactivesearch'
import '../css/SearchApp.scss';
const { ResultCardsWrapper } = ReactiveList;


export class SearchApp extends Component {
    render() {
        return (
            <div className="searchApp">

                <ReactiveBase
                    app="site_search"
                    type="_doc"
                    url="https://9866a2af51504110a0def88ea0d080b2.europe-north1.gcp.elastic-cloud.com:9243"
                    headers={{Authorization: 'ApiKey SHZMbkFYUUJXdFl0QnNsdHJROTc6VmhpR3hLOTdTRHlncVd6Y0l6bk5yUQ=='}}
                >

                    {/*<CategorySearch
                        componentId="sok"
                        className="searchBox"
                        dataField={["title","description","qstring"]}
                        fieldWeights={[3,2,1]}
                        categoryField="parent_category_keyword"
                        placeholder="Søk på Gjerrigknark.com"
                        defaultSuggestions={[{label: "velkomstgave", value: "velkomstgaver"},{label: "gratis ting", value: "gratis ting"},{label: "gode tilbud & kampanjer", value: "gode tilbud & kampanjer"},{label: "insidertips", value: "insidertips"},{label: "spare penger", value: "spare penger"}]}
                        fuzziness={"AUTO"}
                        queryFormat="and"
                        showFilter={true}
                        filterLabel="Søkeuttrykk"
                        URLParams={true}

                        react={{
                            and: ["parentCategoryDataList", "category_cloud", "sok"]
                        }}


                        autoSuggest={true}
                        onSuggestion={(res)=>({
                            label: (<div>{res._source.title}</div>),
                            value: res._source.title
                        })}

                        showClear={true}
                        highlight={true}
                        highlightField={["title","description"]}
                        enableSynonyms={true}
                    />*/}

                    <DataSearch
                        componentId="sok"
                        className="searchBox"
                        dataField={["title","description","qstring"]}
                        fieldWeights={[3,2,1]}
                        categoryField="parent_category_keyword"
                        placeholder="Søk på Gjerrigknark.com"
                        defaultSuggestions={[{label: "velkomstgave", value: "velkomstgaver"},{label: "gratis ting", value: "gratis ting"},{label: "gode tilbud & kampanjer", value: "gode tilbud & kampanjer"},{label: "insidertips", value: "insidertips"},{label: "spare penger", value: "spare penger"}]}
                        fuzziness={"AUTO"}
                        queryFormat="and"
                        showFilter={true}
                        filterLabel="Søkeuttrykk"
                        URLParams={true}

                        react={{
                            and: ["parentCategoryDataList", "category_cloud", "sok"]
                        }}


                        autoSuggest={true}
                        onSuggestion={(res)=>({
                            label: (<div>{res._source.title}</div>),
                            value: res._source.title
                        })}

                        showClear={true}
                        highlight={true}
                        highlightField={["title","description"]}
                        enableSynonyms={true}
                    />

                    <SelectedFilters
                        showClearAll={false}
                        clearAllLabel="Fjern alle filter"
                    />


                    <div className="sideBar">
                        <SingleDataList
                            componentId="parentCategoryDataList"
                            dataField="parent_category_keyword"
                            filterLabel="Kategori"
                            title="Kategorifilter"
                            showSearch={false}
                            data={
                                [{
                                    label: "Gratis ting & vareprøver",
                                    value: "Gratis ting & vareprøver",
                                }, {
                                    label: "Tilbud & kampanjer",
                                    value: "Gode tilbud & kampanjer"
                                }, {
                                    label: "Konkurranser",
                                    value: "Konkurranser"
                                }, {
                                    label: "Sparetips",
                                    value: "Sparetips & triks"
                                }]
                            }
                        />

                        <TagCloud
                            className="cloud categoryCloud"
                            componentId="category_cloud"
                            filterLabel="Tagg"
                            dataField="category_keyword"
                        />
                    </div>

                    {/*<ResultCard
                        target="_self"
                        className="searchResults"
                        componentId="result"
                        loader="Søker..."
                        title="Søkeresultater"
                        dataField="featured"
                        sortBy="desc"
                        stream={false}
                        from={0}
                        size={20}
                        pagination={false}
                        showResultStats={false}
                        onNoResults="Ingen resultater ble funnet"
                        react={
                            {"and": ["sok","category_cloud","parentCategoryDataList"]}
                        }
                        onData={(res) => {
                            //console.log(res);
                            return {
                                image: res.image,
                                title: res.title,
                                url: res.permalink + '#ref=search',
                                description: res.description
                            }
                        }}
                    />*/}

                    <ReactiveList
                        react={
                            {"and": ["sok","category_cloud","parentCategoryDataList"]}
                        }
                        componentId="result"
                        loader="Søker.."
                        stream={false}
                        sortBy="desc"
                        pagination={false}
                        target="_self"
                        dataField="featured"
                        showResultStats={false}
                        renderError={(error) => (
                            <div style={{color:'red'}}>Det har oppstått en feil.</div>
                        )}
                        render={({ data }) => (
                            <ReactiveList.ResultCardsWrapper>
                                {data.map(item => (
                                    <a key={item._id} href={item.permalink+'?rov=search'}>
                                    <ResultCard>
                                            <ResultCard.Image alt={item.title.replace(/<.+?>/g,'')} title={item.title.replace(/<.+?>/g,'')} src={item.image} />

                                            <ResultCard.Title>
                                                <div title={item.title.replace(/<.+?>/g)}
                                                    className="book-title"
                                                    dangerouslySetInnerHTML={{
                                                        __html: item.title,
                                                    }}
                                                />
                                            </ResultCard.Title>

                                            <ResultCard.Description>
                                                <div className="flex column justify-space-between">
                                                    <div>
                                                        <div className="ratings-list flex align-center" style={{textDecoration:'none !important'}}
                                                             dangerouslySetInnerHTML={{
                                                                 __html: item.description,
                                                             }}
                                                        />
                                                    </div>
                                                </div>
                                            </ResultCard.Description>
                                        </ResultCard>
                                    </a>
                                ))}
                            </ReactiveList.ResultCardsWrapper>
                        )}
                    >

                    </ReactiveList>




                </ReactiveBase>
            </div>
        );
    }
}

export default SearchApp;